<template>
  <div class="retailOrderPay" >
    <XR-Result icon="fa fa-no2" bgColor="red" msg="支付失败" :content="content"></XR-Result>
  </div>
</template>

<script>
export default {
  data () {
    return {
      content:this.$route.query.content
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/shangquan/sqPayFailed.vue